// Pure path-math for selecting an entire table row or column. Shared by the
// cell context menu (tableElements) and the row/column drag-handles
// (TableHandlesOverlay) so the grid-coordinate logic lives in one place; each
// caller keeps its own side effects (focus, scroll restoration). Returns null
// paths when the table/row is empty so callers can short-circuit before
// touching the editor.
export function calculateSelectionRange(
    axis: 'row' | 'column',
    tableNode: any,
    tablePath: number[],
    index: number,
): { start: number[] | null; end: number[] | null } {
    if (!tableNode?.children?.length) return { start: null, end: null };
    if (axis === 'row') {
        const row = tableNode.children[index];
        if (!row?.children?.length) return { start: null, end: null };
        return { start: [...tablePath, index, 0], end: [...tablePath, index, row.children.length - 1] };
    }
    return { start: [...tablePath, 0, index], end: [...tablePath, tableNode.children.length - 1, index] };
}
